import React, { useEffect, useState } from "react";

import { useBroadcastEditContext } from "./BroadcastEditContainer";
import { flattenLiquidData } from "../../../shared/liquidUtils";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  fontSize: 14,
  gap: 15,
};

const headerStyle = {
  borderBottom: "1px solid var(--sl-border-subtle)",
  color: "var(--sl-text-tertiary)",
  fontSize: 10,
  paddingBottom: 5,
  width: "100%",
};

const rowStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  textWrap: "nowrap",
  width: "100%",
};

const pathStyle = {
  color: "var(--sl-text-tertiary)",
};

const valueStyle = {
  color: "var(--sl-fg-brand)",
};

const SampleDataContainer = () => {
  const { sampleData } = useBroadcastEditContext();

  const [flattenedSampleData, setFlattenedSampleData] = useState([]);

  useEffect(() => {
    setFlattenedSampleData(flattenLiquidData(sampleData));
  }, [sampleData])

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        ATTRIBUTES
      </div>
      {flattenedSampleData.map(({ path, value }) => (
        !!value ? (
          <div key={path} style={rowStyle}>
            <div style={pathStyle}>{path}</div>
            <div style={valueStyle}>{`"${value}"`}</div>
          </div>
        ) : null
      ))}
    </div>
  );
};

export default SampleDataContainer;
